import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImageInput from './component';
import { readImageFile } from './utils';

/**
 * Wrapper function for raw file input onChange callback. Process the image files and depending
 * on its success calls the client's onImageUpload or onError calllbacks.
 */
export const handleImageUpload = (success, error) => async (
  imageUploadEvent,
) => {
  imageUploadEvent.preventDefault();
  // Array.from to turn FileList to Array.
  const files = Array.from(imageUploadEvent.target.files);
  if (!files) return;

  let images;
  try {
    images = await Promise.all(files.map(readImageFile));
  } catch (e) {
    error(e);
    return;
  }
  success({
    files, // Files to upload to alongside the review.
    images, // Base64 encoded image data to display thumbnails before upload.
  });
};

class ImageInputContainer extends Component {
  render() {
    const { onImageUpload, onError, ...rest } = this.props;

    return (
      <ImageInput
        onImageUpload={handleImageUpload(onImageUpload, onError)}
        {...rest}
      />
    );
  }
}

ImageInputContainer.propTypes = {
  // Callback to pass processed form input events when an image is submitted.
  onImageUpload: PropTypes.func,
  images: PropTypes.arrayOf(PropTypes.string),
};

ImageInputContainer.defaultProps = {
  onImageUpload: () => {},
  images: [],
};

export default ImageInputContainer;
